import { create } from "zustand";
import { devtools } from "zustand/middleware";
/** Controls the create-task flow of the patient tasks panel so it can be opened from anywhere. */
export var usePatientTasksStore = create()(devtools(function (set) {
  return {
    isCreating: false,
    prefillState: {},
    startCreate: function startCreate() {
      var prefill = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return set({
        isCreating: true,
        prefillState: prefill
      }, false, "startCreate");
    },
    stopCreate: function stopCreate() {
      return set({
        isCreating: false,
        prefillState: {}
      }, false, "stopCreate");
    }
  };
}, {
  name: "PatientTasksStore",
  enabled: typeof window !== "undefined" && process.env.NODE_ENV !== "production"
}));